import {
  LOADING_ANIMATION_IMAGE,
  PROFILE_PLACEHOLDER_IMAGE,
} from "./constants";

export { LOADING_ANIMATION_IMAGE, PROFILE_PLACEHOLDER_IMAGE };

/**
 * Resolves a profile image URL, falling back to the shared placeholder SVG.
 * `preview` wins when the user has picked a new file in an upload form.
 */
export function resolveProfileImageSrc({
  baseUrl = "",
  profilePicture = "",
  preview = "",
} = {}) {
  const selectedPreview =
    preview != null && String(preview).trim() !== ""
      ? String(preview).trim()
      : "";

  if (selectedPreview) {
    return selectedPreview;
  }

  const picture =
    profilePicture != null && String(profilePicture).trim() !== ""
      ? String(profilePicture).trim()
      : "";

  if (picture) {
    const base = baseUrl != null ? String(baseUrl) : "";
    return `${base}${picture}`;
  }

  return PROFILE_PLACEHOLDER_IMAGE;
}
